<mat-grid-tile-header>
  <h3>Taille : {{ article.taille }}</h3>
  <h3>Règle de change : {{ article.change + '/' + article.stock}}</h3>
</mat-grid-tile-header>

<div id="content">
  <div *ngIf="+article.change===0 && +article.stock===0" matTooltip="L'article est en cours de commande"
    matTooltipPosition="right" class="badge-color">
    <mat-icon>schedule</mat-icon>
  </div>
  <div *ngIf="+article.is_withdrawal" matTooltip="Demande de retrait en cours" matTooltipPosition="right"
    class="badge-color small">
    <mat-icon>auto_delete</mat-icon>
  </div>
  <img mat-card-image [src]="getSvg()" />
  <h3 class="mt-0">{{ article.code_article }}</h3>
  <h3 class="mt-0">{{ article.designation }}</h3>
</div>

<mat-grid-tile-footer class="flex justify-between">
  <div (click)="openEdit()">
    <mat-icon>create</mat-icon>
    <div class="font-bold">Modifier</div>
  </div>

  <div (click)="delete()">
    <mat-icon>delete</mat-icon>
    <div class="font-bold">Retirer</div>
  </div>
</mat-grid-tile-footer>